import {
    useGetIDsFromURL,
    verifySingleStack,
} from 'components/DeviceDetails/helper';
import { useGetSiteData } from 'components/SiteDetails/helper';
import { useDevice } from 'components/DeviceDetails/service';

export const useBreadCrumbLabels = () => {
    const IDs = useGetIDsFromURL();
    const {
        baseRoute,
        Thing_ID,
        Site_ID,
        BMS_ID,
        Module_ID,
        addEdit,
        history,
        UpdateID,
        logs,
        pathname,
    } = IDs;
    const { data: device } = useDevice(Thing_ID);
    const { data: siteData } = useGetSiteData(Site_ID);
    const matchedDevice = device?.Thing_ID === Thing_ID ? device : null;
    const { SINGLE_BMS_ID } = verifySingleStack(matchedDevice);

    const pathParts = pathname.split('/').filter(Boolean);

    const getHref = (segment) => {
        const idx = pathParts.indexOf(segment);
        if (idx === -1) return null;
        return '/' + pathParts.slice(0, idx + 1).join('/');
    };

    const crumbs = [];

    if (baseRoute) {
        crumbs.push({ label: baseRoute, href: `/${baseRoute}` });
    }

    if (Thing_ID) {
        const deviceLoaded = device?.Thing_ID === Thing_ID;
        const label = !deviceLoaded
            ? '...'
            : Thing_ID.includes('NEP')
              ? 'Gateway'
              : SINGLE_BMS_ID
                ? 'BMS'
                : 'System';
        crumbs.push({ label, href: getHref(Thing_ID) });
    } else if (Site_ID) {
        crumbs.push({ label: siteData?.Address ?? '...', href: getHref(Site_ID) });
    }

    if (BMS_ID) {
        // For single-stack, BMS_ID may be either the MASTER_SN (BMS-level navigation)
        // or a PACK_SN (module-level navigation).
        // If it equals SINGLE_BMS_ID, it's the BMS itself — skip it since Thing_ID
        // already represents the BMS level for single-stack devices.
        const isBMSSerial = SINGLE_BMS_ID && BMS_ID === SINGLE_BMS_ID;
        if (!isBMSSerial) {
            const label = SINGLE_BMS_ID ? 'Module' : 'BMS';
            crumbs.push({ label, href: getHref(BMS_ID) });
        }
    }

    if (Module_ID) {
        crumbs.push({ label: 'Module', href: getHref(Module_ID) });
    }

    if (addEdit) {
        crumbs.push({ label: addEdit.replace(/-/g, ' '), href: getHref(addEdit) });
    }

    if (history) {
        crumbs.push({ label: 'Upgrade History', href: getHref(history) });
    }

    if (UpdateID) {
        crumbs.push({ label: UpdateID ?? 'Upgrade Log Details', href: getHref(UpdateID) });
    }

    if (logs) {
        crumbs.push({ label: 'Logs', href: null });
    }

    return { crumbs };
};
